import { render } from "./VDropdownSection.vue?vue&type=template&id=2b6b900c&ts=true"
import script from "./VDropdownSection.vue?vue&type=script&lang=ts"
export * from "./VDropdownSection.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__